<template>
  <form>
    <InputField
      v-model="innerName"
      name="名前"
      label="名前"
      class="mb-4"
      :disabled="true"
      full-width
    />
    <InputField
      v-model="innerAdvertiser"
      name="広告アカウント"
      label="広告アカウント"
      class="mb-7"
      :disabled="true"
      full-width
    />
    <vx-card>
      <DataTable
        class="amc-audience-delivery-table"
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="rowData"
        :total="total"
        :current-page="currentPage"
        :grid-options="gridOptions"
        :columnsToFit="false"
        domLayout="autoHeight"
        @update:current-page="onUpdateCurrentPage"
        style="height: inherit;"
      />
    </vx-card>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import InputField from '@/components/fields/InputField'
import DataTable from '@/components/table/DataTable'
import { debounce } from '@/utils'

export default {
  name: 'AmcAudienceDeliveryListForm',
  components: {
    InputField,
    DataTable
  },
  props: {
    audienceId: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    advertiserId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 20,
      defaultColDef: {
        sortable: false,
        editable: false,
        resizable: false,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ステータス',
          field: 'status',
          valueFormatter (params) {
            return params.value ? params.value : '未実行'
          }
        },
        {
          headerName: 'エラー',
          field: 'statusReason'
        },
        {
          headerName: 'タイプ',
          field: 'adType'
        },
        {
          headerName: 'キャンペーン',
          field: 'campaignName'
        },
        {
          headerName: '広告グループ',
          field: 'adGroupName'
        },
        {
          headerName: '入札調整額',
          field: 'bidAjustment'
        },
        {
          headerName: '入札金額',
          field: 'bid'
        },
        {
          headerName: '作成日',
          field: 'createdAt'
        },
        {
          headerName: '更新日',
          field: 'updatedAt'
        }
      ],
      gridOptions: {
        autoSizeStrategy: {
          type: 'fitCellContents'
        },
      }
    }
  },
  computed: {
    ...mapState('amcAudience', ['deliveryList']),
    rowData: {
      get () {
        return JSON.parse(JSON.stringify(this.deliveryList))
      }
    },
    innerName: {
      get () {
        return this.name
      },
      set () {
      }
    },
    innerAdvertiser: {
      get () {
        return this.advertiserId
      },
      set () {
      }
    }
  },
  methods: {
    ...mapActions('amcAudience', ['listDeliveries']),
    fetchData: debounce(async (self) => {
      try {
        const payload = {
          amcAudienceId: self.audienceId,
          page: self.currentPage,
          per_page: self.pageSize
        }
        const res = await self.listDeliveries(payload)
        self.total = res.data.total
      } catch (e) {
        console.log(e)
      }
    }, 500),
    onUpdateCurrentPage (val) {
      this.currentPage = val
      this.fetchData(this)
    },
  }
}
</script>

<style scoped>
.amc-audience-delivery-table :deep(.ag-center-cols-viewport) {
  min-height: auto !important;
}
</style>
